import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

class CanonicalHelmet extends Component {
  render() {
    const { location } = this.props;
    const canonicalUrl = `https://web.uat-akash-go.com${location.pathname}`;

    return (
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
    );
  }
}

// Export the component wrapped in withRouter
export default withRouter(CanonicalHelmet);